import { render, staticRenderFns } from "./VariableTest.vue?vue&type=template&id=90ff409a&scoped=true"
import script from "./VariableTest.vue?vue&type=script&lang=js"
export * from "./VariableTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ff409a",
  null
  
)

export default component.exports